import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import moment from 'moment';

export class DemoozWeekDay {
    numDay: number;
    name: string;
    constructor(name: string, numDay: number){
        this.name = name;
        this.numDay = numDay;
    }
}

@Injectable({
  providedIn: 'root'
})
export class DemoozDateService {
    
    private static millisecondsPerDay: number = 24 * 60 * 60 * 1000;
    
    constructor(
        private translateService: TranslateService
    ) { }
    
    static GetToday(): number{
        let date = new Date();
        date.setHours(0, 0, 0);
        let m = moment(date);
        return Math.ceil(parseInt(m.format('x')) / DemoozDateService.millisecondsPerDay);
    }
        
    static GetFirstDayOfMonth(date?: Date): Date{
        let m = (date ? moment(date) : moment());   
        let d = m.startOf('month').toDate();  
        d.setHours(0,0,0);   
        return d;
    }
    
    static GetLastDayOfMonth(date?: Date): Date{
        let m = (date ? moment(date) : moment());   
        let d = m.endOf('month').toDate(); 
        d.setHours(23,59,59);       
        return d;
    }
    
    static GetPreviousMonth(date: Date): Date{     
        return moment(date).subtract(1, 'month').toDate();
    }
    
    static GetNextMonth(date: Date): Date{     
        return moment(date).add(1, 'month').toDate();
    }
    
    static GetFirstDayOfWeek(date?: Date): Date{
        let m = (date ? moment(date) : moment()); 
        let d = m.isoWeekday(1).toDate();       
        d.setHours(0,0,0);   
        return d;
    }
    
    static GetLastDayOfWeek(date?: Date): Date{
        let m = (date ? moment(date) : moment());        
        let d = m.isoWeekday(7).toDate();
        d.setHours(23,59,59);       
        return d;
    }
        
    static GetPreviousWeek(date: Date): Date{     
        return moment(date).subtract(1, 'week').toDate();
    }
    
    static GetNextWeek(date: Date): Date{     
        return moment(date).add(1, 'week').toDate();
    }
            
    static ToISOString(date: Date){
        return moment(date).toISOString();
    }
    
    static ToTime(date: Date): string|null{
        let time = null;
        let m = moment(date);
        if(m.isValid()){
            time = m.format('HH:mm');
        }
        return time;
    }        
    
    static FromTime(timeStr: string, sep: string = ':'): Date{
        let d = new Date();
        if(timeStr && timeStr != ''){
            let times = timeStr.split(sep);
            if(times.length >= 2){
                d.setHours(parseInt(times[0]));
                d.setMinutes(parseInt(times[1]));
                if(times.length === 3){
                    d.setSeconds(parseInt(times[3]));                
                }
            }            
        }
        return d;
    }
        
    static GetDuration(startTime: Date, endTime: Date): number {        
        return Math.abs(endTime.valueOf() - startTime.valueOf()) / (1000 * 60);
    }
        
    static MinutesToStr(minutes: number, sep: string = ':'): string{
        let r = (minutes / 60);
        let h = Math.floor(r);
        let m = Math.ceil((r - h) * 60);
        if(m >= 60){
            h++;
            m = 0;
        }
        return h+sep+m.toString().padStart(2, '0');
    }
    
    static StrToMinutes(time: string, sep: string = ':'): number{
        let minutes = 0;
        let t = time.split(sep);
        if(t.length >= 2){
            minutes = (parseInt(t[0]) * 60 + parseInt(t[1]));
        }        
        return minutes
    }
    
    static ParseFromString(str: string): Date|null {
        let date: Date|null = null;
        let dateStr: string = '';
        let regexWeek = new RegExp(/(semaine(s)?|week(s)?)/,'i');
        if(str.match(regexWeek)){
            
            str = str.replace(new RegExp(/[^0-9\s]/, 'g'), '').trim();
            str = str.replace(new RegExp(/\s{2,}/, 'g'), ' ');
            str = str.replace(new RegExp(/\s/, 'g'), '-');
            
            let tabStr = str.split('-');
            let year = moment().format('YYYY');
            if(tabStr.length === 2 && tabStr[1].length === 4){
                year = tabStr[1];
            }            
            if(tabStr.length === 1 || tabStr.length === 2){
                dateStr = year+'-'+tabStr[0].padStart(2, '0');
            } 
                        
            if(dateStr !== ''){
                let m = moment(dateStr, 'YYYY-WW');
                if(m.isValid()){
                    date = DemoozDateService.GetFirstDayOfWeek(m.toDate());
                }
            }
            
        }
        else{
            for(let i=1;i<=12;i++){
                let month = moment(i,'M');
                str = str.replace(new RegExp(month.format('MMMM'),'i'), month.format('MM'));
            }        
            str = str.replace(new RegExp(/[^0-9\s]/, 'g'), '').trim();      
            str = str.replace(new RegExp(/\s{2,}/, 'g'), ' ');  
            str = str.replace(new RegExp(/\s/, 'g'), '-'); 

            let tabStr = str.split('-');
            let year = moment().format('YYYY');
            
            if (tabStr.length === 3 && tabStr[2].length === 4){
                year = tabStr[2];
            }
            
            if (tabStr.length === 2 && tabStr[1].length === 4){
                year = tabStr[1];
            }
            
            if(tabStr.length === 1 || tabStr.length === 2){                
                dateStr = year+'-'+tabStr[0].padStart(2, '0')+'-01';                          
            }
            else if (tabStr.length === 3){                
                dateStr = year+'-'+tabStr[1].padStart(2, '0')+'-'+tabStr[0].padStart(2, '0');                
            }
            
            if(dateStr !== ''){
                let m = moment(dateStr, 'YYYY-MM-DD');
                if(m.isValid()){
                    date = m.toDate();
                }
            }
        }
        
        
        return date;
    }
    
    static GetWeekDays(short: boolean = false): Array<DemoozWeekDay>{
        let format = (short ? 'ddd' : 'dddd');
        return [
            new DemoozWeekDay(moment().isoWeekday(1).format(format), 1), 
            new DemoozWeekDay(moment().isoWeekday(2).format(format), 2),
            new DemoozWeekDay(moment().isoWeekday(3).format(format), 3),
            new DemoozWeekDay(moment().isoWeekday(4).format(format), 4),
            new DemoozWeekDay(moment().isoWeekday(5).format(format), 5),
            new DemoozWeekDay(moment().isoWeekday(6).format(format), 6),
            new DemoozWeekDay(moment().isoWeekday(7).format(format), 7)
        ];
    }
    
    static GetNthWeekdayOfMonth(month: Date, nth: number, dow: number, forceLast: boolean = false): Date|null{  
    
        let start = moment(DemoozDateService.GetFirstDayOfMonth(month));
        start.isoWeekday(dow);
        let startMonth = moment(DemoozDateService.GetFirstDayOfMonth(month));
        let endMonth = moment(DemoozDateService.GetLastDayOfMonth(month));
        let days: Array<Date> = [];
        while(start <= endMonth){            
            if(startMonth <= start){
                days.push(start.toDate());
            }
            start.add(7, 'days');
        }  
        return (typeof days[(nth-1)] !== 'undefined' ? days[(nth-1)] : ((forceLast || nth === 5) && days.length > 0 ? days[(days.length-1)] : null));
    } 
    
    static IsPublicHolidays(date: Date): boolean{        
        let m = moment(date);
        let publicHolidays = DemoozDateService.GetPublicHolidays(m.year());        
        return (publicHolidays.indexOf(m.format('YYYY-MM-DD')) !== -1);
    }
    
    static GetPublicHolidays(year: number){
        let publicHolidays: Array<string> = [
            year+'-01-01', // 1er janvier
            year+'-05-01', // Fête du travail
            year+'-05-08', // Victoire des alliés
            year+'-07-14', // Fête nationale
            year+'-08-15', // Assomption
            year+'-11-01', // Toussaint
            year+'-11-11', // Armistice
            year+'-12-25', // Noel
        ];     
        
        let easterDate = moment(DemoozDateService.getEasterDate(year));       
        publicHolidays.push(easterDate.clone().add(1, 'days').format('YYYY-MM-DD')); // Pâques
        publicHolidays.push(easterDate.clone().add(39, 'days').format('YYYY-MM-DD')); // Ascension
        publicHolidays.push(easterDate.clone().add(50, 'days').format('YYYY-MM-DD')); // Pentecôte
           
        return publicHolidays;
    }
    
    static SetMomentLocale(langShortCode: string){
        moment.locale(langShortCode);
    }
    
    static getEasterDate(Y: number): Date {
        var C = Math.floor(Y/100);
        var N = Y - 19*Math.floor(Y/19);
        var K = Math.floor((C - 17)/25);
        var I = C - Math.floor(C/4) - Math.floor((C - K)/3) + 19*N + 15;
        I = I - 30*Math.floor((I/30));
        I = I - Math.floor(I/28)*(1 - Math.floor(I/28)*Math.floor(29/(I + 1))*Math.floor((21 - N)/11));
        var J = Y + Math.floor(Y/4) + I + 2 - C + Math.floor(C/4);
        J = J - 7*Math.floor(J/7);
        var L = I - J;
        var M = 3 + Math.floor((L + 40)/44);
        var D = L + 28 - 31*Math.floor(M/4);

        let m = moment();
        m.year(Y);
        m.month((M-1));
        m.date(D);
        m.hour(0);
        m.minute(0);
        m.second(0);
        
        return m.toDate();
    }
    
    static InitMomentLocale(){
        moment.locale('fr', {
            months : ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
            monthsShort : ['Janv.','Févr.','Mars','Avr.','Mai','Juin','Juil.','Août','Sept.','Oct.','Nov.','Déc.'],
            monthsParseExact : true,
            weekdays : ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],
            weekdaysShort : ['Dim.','Lun.','Mar.','Mer.','Jeu.','Ven.','Sam.'],
            weekdaysMin : ['Di','Lu','Ma','Me','Je','Ve','Sa'],
            weekdaysParseExact : true,
            longDateFormat : {
                LT : 'HH:mm',
                LTS : 'HH:mm:ss',
                L : 'DD/MM/YYYY',
                LL : 'D MMMM YYYY',
                LLL : 'D MMMM YYYY HH:mm',
                LLLL : 'dddd D MMMM YYYY HH:mm'
            },
            calendar : {
                sameDay : '[Aujourd’hui à] LT',
                nextDay : '[Demain à] LT',
                nextWeek : 'dddd [à] LT',
                lastDay : '[Hier à] LT',
                lastWeek : 'dddd [dernier à] LT',
                sameElse : 'L'
            },
            relativeTime : {
                future : 'dans %s',
                past : 'il y a %s',
                s : 'quelques secondes',
                m : 'une minute',
                mm : '%d minutes',
                h : 'une heure',
                hh : '%d heures',
                d : 'un jour',
                dd : '%d jours',
                M : 'un mois',
                MM : '%d mois',
                y : 'un an',
                yy : '%d ans'
            },
            dayOfMonthOrdinalParse : /\d{1,2}(er|e)/,
            ordinal : function (number) {
                return number + (number === 1 ? 'er' : 'e');
            },
            meridiemParse : /PD|MD/,
            isPM : function (input) {
                return input.charAt(0) === 'M';
            },
            // In case the meridiem units are not separated around 12, then implement
            // this function (look at locale/id.js for an example).
            // meridiemHour : function (hour, meridiem) {
            //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
            // },
            meridiem : function (hours, minutes, isLower) {
                return hours < 12 ? 'PD' : 'MD';
            },
            week : {
                dow : 1, // Monday is the first day of the week.
                doy : 4  // Used to determine first week of the year.
            }
        });
    }
}
